// Release notes, shown to all users via "What's New" in the profile menu.
// Append a new entry at the TOP in the same commit/PR as the changes it
// describes, written in plain product language.
export const changelog = [
  {
    date: '2026-07-15',
    title: 'Ticket Type options for Mastercard Collection Entertainment',
    items: [
      'With Entertainment selected in the Mastercard Collection browser, new Ticket Type sub-options appear: Preferred Ticket and Presale Ticket.',
      'Sub-type filters now narrow only their own category — a Dining Type selection no longer hides Entertainment or Travel content still selected in the tree, and vice versa.',
    ],
  },
  {
    date: '2026-07-15',
    title: 'Guide appears each session',
    items: [
      'The welcome guide with quick-start presets now opens once per browser session, not just on your very first visit.',
      'Prefer not to see it? Tick “Don’t show this again” on the welcome card — the Guide button above the filters always stays available.',
    ],
  },
  {
    date: '2026-07-15',
    title: 'Exclude specific programs',
    items: [
      'New “Exclude Content Source Programs” filter under Exclusions — hide content from any programs you select.',
      'It replaces the Live Nation-only exclusion checkbox, which is now just one of the selectable programs.',
      'The Search Summary now describes active exclusions in plain language.',
    ],
  },
  {
    date: '2026-07-14',
    title: 'Clearer availability filtering',
    items: [
      'The Expiration Date filter is replaced by “When is the content available?” — pick a date range and see everything that is live at any point during that period, regardless of when it expires. Leave either end open for “from…” / “until…” searches.',
      'Added an explanatory tooltip to the Activation Month filter.',
    ],
  },
  {
    date: '2026-07-13',
    title: 'Guided tour now available to everyone',
    items: [
      'The guided tour and quick-start presets are out of admin beta — all users see the tour on their first visit, and can replay it anytime via the Guide button above the filters.',
    ],
  },
  {
    date: '2026-07-13',
    title: 'Benefits & Travel Benefits join the catalog',
    items: [
      'Benefits and Travel Benefits (MTR) content is now part of the catalog.',
      'Both are excluded from results by default — include them via Filters → Exclusions.',
      'Benefits can also be selected under the Content Type filter.',
    ],
  },
  {
    date: '2026-07-12',
    title: 'Guided tour & quick-start presets (Beta, Admin-only)',
    items: [
      'First visit to the catalog now offers a short guided tour of the filters, plus one-click starting points for the three common use cases (B2C, B2B2C via The Mastercard Collection, B2B2C via Priceless.com).',
      'Replay it anytime via the Guide control above the filters.',
    ],
  },
  {
    date: '2026-07-09',
    title: 'Mastercard Collection categories',
    items: [
      "The Mastercard Collection browser now groups programs by the collection's own categories — Travel, Entertainment, and Dining — instead of passion category.",
      'Dining Experiences / Dining Hotspot options now appear under the Dining category.',
    ],
  },
  {
    date: '2026-07-09',
    title: 'Catalog layout & filters overhaul',
    items: [
      'Catalog now uses the full width of your screen, with up to 4 result cards per row.',
      'Filters are grouped into collapsible sections with badges showing how many selections are active inside each.',
      'Pass-Through Rights options appear only when a B2B implementation type is selected.',
      'Result thumbnails show the full image (previously cropped to a center slice).',
      'Improved layout on tablets and smaller screens.',
    ],
  },
  {
    date: '2026-07-07',
    title: 'Mastercard Collection program browser + access rules',
    items: [
      'Selecting “The Mastercard Collection only” now shows every program in the collection, grouped by passion category, with the ability to narrow to specific programs. The list is generated from live catalog data.',
      'B2B (partner specific) content is now visible to admins only.',
      'Users with export privileges can download CSVs (previously admins only).',
    ],
  },
  {
    date: '2026-07-06',
    title: 'Mastercard Collection filter & sponsorships calendar',
    items: [
      'New “The Mastercard Collection” filter with Dining Experiences / Dining Hotspot options.',
      '2026 Sponsorships Calendar available from the Linked Sponsorship filter.',
    ],
  },
  {
    date: '2026-06-29',
    title: 'Filter improvements',
    items: [
      'Filter sidebar reordered for a more logical flow.',
      'Added a notice when a language filter is active and results include Coming Soon content (which has no language data yet).',
    ],
  },
  {
    date: '2026-06-28',
    title: 'Smarter B2B/B2C and aggregator filtering',
    items: [
      'Implementation Type (B2B / B2C) filtering now uses a precomputed classification for more accurate results.',
      'New standalone Content Aggregator filter (Withlocals, Fever, Viator, Toristy).',
    ],
  },
  {
    date: '2026-06-27',
    title: 'New filters & cleanups',
    items: [
      'New Card Type and Program Name filters.',
      'Pipeline (coming soon) content shows N/A instead of an internal product ID.',
    ],
  },
];
